interface DetailsPopoverItemPropertyProps {
  label: string;
  value: any;
}

const DetailsPopoverItemProperty = (props: DetailsPopoverItemPropertyProps) => {
  const { label, value } = props;

  return (
    <div className="item-row-container-row">
      <div className="item-row-container-row-cell bold">{label}:</div>
      <div className="item-row-container-row-cell">{value}</div>
    </div>
  );
};

export default DetailsPopoverItemProperty;
